import { Link } from "react-router-dom";
import { useEffect } from "react";

//Props Validations
import PropTypes from "prop-types";

//import component
import FiltersHeaderLabel from "../components/common/FiltersHeaderLabel";
import Header from "../components/common/Header";
import MatchNetLookupTable from "../components/matchNet/MatchNetLookupTable";
import FullScreenConatiner from "../components/layouts/FullScreenConatiner";
import MatchNetNavigation from "components/common/MatchNetNavigation";

// mui icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// redux
import { useDispatch, useSelector } from "react-redux";
import { loadLookupSelectedProductsState, loadCompareEnabledState } from "store/features/matchNetSlice";

function MatchNetLookupPage({ headerTitle = "" }) {
    const dispatch = useDispatch();
    const selectedStudyType = useSelector((state) => state.matchNetStore.selectedStudyType);
    const isCompareEnabled = useSelector((state) => state.matchNetStore.isCompareEnabled);

    useEffect(() => {
        dispatch(loadLookupSelectedProductsState([]));
        dispatch(loadCompareEnabledState(false));
    }, [dispatch]);

    return (
        <div>
            <Header
                title={headerTitle}
                titleSuffix={selectedStudyType !== "" ? (selectedStudyType === "home_use_test" ? "(Home Use Test Compatibility Context)" : "(Fragrance Testing Compatibility Context)") : ""}
                isStudySelected={false}
            />
            <div
                className=""
                style={{
                    width: 150,
                    display: "flex",
                    alignItems: "center",
                    position: "absolute",
                    zIndex: 10,
                }}
            >
                <Link to="/match-net">
                    <div
                        className="p-2 liner-light-blue-background color-white"
                        style={{
                            borderRadius: "50%",
                            position: "relative",
                            top: 52,
                            left: 10,
                            cursor: "pointer",
                        }}
                    >
                        <span>
                            <ArrowBackIcon className="color-white" />
                        </span>
                    </div>
                </Link>
            </div>
            <div
                style={{
                    display: "flex",
                    marginTop: 11,
                    marginBottom: 0,
                }}
                className="ms-4 mb-0 me-4"
            >
                <div
                    className=" background-color-white box-shadow--2 d-flex"
                    style={{
                        borderRadius: "5px",
                        minWidth: "calc(100vw - 50px)",
                    }}
                >
                    <FiltersHeaderLabel multipleLabel={true} />
                </div>
            </div>
            <FullScreenConatiner>
                <div
                    style={{
                        minWidth: "calc(100% - 220px)",
                    }}
                    className="p-2 mb-0 mx-4 pt-4"
                >
                    <MatchNetLookupTable />
                </div>
                <div
                    style={{
                        position: "relative",
                        top: "5px",
                        marginTop: "30px",
                    }}
                >
                    <MatchNetNavigation
                        buttons={["CrossCompareKeyMetrics"]}
                        isDisabled={!isCompareEnabled}
                    />
                </div>
            </FullScreenConatiner>
        </div>
    );
}

// Typechecking props for the Study
MatchNetLookupPage.propTypes = {
    headerTitle: PropTypes.string,
};

export default MatchNetLookupPage;
